import { validate as uuidValidate } from 'uuid';

import { BASKET_ID_PARAM } from '@constants/queryParams';
import { BASKET_ID_KEY } from '@constants/storageKeys';

const hasBasket = () => {
  const fromSession = !!window.sessionStorage.getItem(BASKET_ID_KEY);
  const fromLocalStorage = !!localStorage.getItem(BASKET_ID_KEY);
  const param = new URLSearchParams(window.location.search).get(
    BASKET_ID_PARAM
  );
  const fromUrl = !!param && uuidValidate(param);

  return fromSession || fromLocalStorage || fromUrl;
};

export { hasBasket };
